import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { IHomePageService } from './interfaces';
import { HOME_PAGE } from './opaque-tokens';

export abstract class BaseHomePageService implements IHomePageService {
  protected abstract router: Router;
  protected abstract route: ActivatedRoute;

  redirectToHome() {
    return this.getHomeUrl().pipe(
      mergeMap((url) => {
        this.router.navigateByUrl(this.route.snapshot.queryParams.redirectUrl || url);
        return EMPTY;
      }),
    );
  }
  abstract getHomeUrl(): Observable<string>;
}

@Injectable()
export class SimpleHomePageService extends BaseHomePageService implements IHomePageService {
  protected router = inject(Router);
  protected route = inject(ActivatedRoute);
  private homePage = inject(HOME_PAGE);

  getHomeUrl(): Observable<string> {
    return of(this.homePage);
  }
}
